import { Flex, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Button, CustomIcon } from 'components';
import { rgba } from 'polished';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from 'hooks/useBreakpoint';

//region styled

const CloseIconWrapper = styled(Flex)`
  cursor: pointer;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 15px;
  transform: translateY(-50%);
  z-index: 2;
`;

const FixedContainer = styled.div`
  position: fixed;
  left: 55px;
  right: 55px;
  bottom: 20px;
  height: 50px;
  z-index: 2;
`;

//endregion

const ProjectClose: FC<{ onCloseIconClick: () => void }> = ({ onCloseIconClick }) => {
  const { t } = useTranslation('projects');
  const { colors } = useTheme();
  const { isTablet } = useBreakpoint();

  return isTablet ? (
    <FixedContainer>
      <Button
        bg="white"
        color="gray.900"
        boxShadow={`0px 4px 20px ${rgba(colors.black, 0.25)}`}
        _hover={{ bg: 'gray.100' }}
        leftIcon={<ArrowBackIcon />}
        width="100%"
        onClick={onCloseIconClick}
      >
        {t('back')}
      </Button>
    </FixedContainer>
  ) : (
    <CloseIconWrapper>
      <CustomIcon onClick={onCloseIconClick} name="close" withBackground backgroundColor={colors.pink['200']} boxSize="36px" p="12px" />
    </CloseIconWrapper>
  );
};

export default ProjectClose;
